/**
 * Creating parsed data for widgets for which this function is called
 * @param {object} widget
 * @return {object} widgetObject with it's type and data
 */

export const parseWidgetData = (
    widgets,
    currentPageNumber = 0,
    totalNumerOfAddress = 0,
    existingAddress = [],
    existingCta = {},
    addressIdSelected = null
) => {
    let widgetData = {}
    let selectedAddressId = null
    let addressCta = {}
    let groupedAddresses = []
    let numberOfAddress = 0
    let hasMore = false
    widgets.forEach((widget) => {
        switch (widget.type) {
            case "list_address": {
                widgetData["listAddress"] = {
                    secondaryCta: {
                        label: widget?.data.secondary_action?.text || "",
                        functionMap: "addNewAddress",
                    },
                    groupedAddresses: widget?.data?.grouped_addresses?.map((item) => {
                        if (currentPageNumber > 0 && item?.header === "Recent addresses") {
                            return
                        } else {
                            return {
                                header: item.header,
                                addresses: item?.addresses?.map((address) => {
                                    numberOfAddress++
                                    if (address?.is_selected) {
                                        selectedAddressId = address?.id
                                    }
                                    if (address?.cta) {
                                        addressCta[address?.id] = {
                                            action: address?.cta?.action,
                                            is_disabled: address?.cta?.is_disabled,
                                            target_url: address?.cta?.target_url,
                                            text: address?.cta?.text,
                                            addressServiceabilityGaData:
                                                address?.address_serviceability_ga_data,
                                            errorMsg: address?.display_text,
                                            pincode: address?.pincode,
                                            address_type: address?.address_type,
                                        }
                                    }
                                    return {
                                        id: address?.id,
                                        name: address?.address_name
                                            ? address?.address_name
                                            : address?.address_type
                                            ? address?.address_type
                                            : "",
                                        addressText: address.street1 || "",
                                        streetName: address.street2 || "",
                                        city: address?.city,
                                        state: address?.state,
                                        pincode: address?.pincode,
                                        recipientName: address?.name,
                                        recipientPhone: address?.contact_number,
                                        actionLabelFirst: address?.action1.text,
                                        actionLabelSecond: address?.action2.text,
                                        isDisabled: address?.is_disabled,
                                        errorMsg: address?.display_text,
                                        addressServiceabilityGaData: address?.address_serviceability_ga_data,
                                        lat: address?.geodata_latitude,
                                        lng: address?.geodata_longitude,
                                        geodataUpdateRequired: address?.is_geodata_update_required,
                                    }
                                }),
                            }
                        }
                    }),
                }

                break
            }
        }
    })
    if (numberOfAddress === 10) {
        hasMore = true
    }
    if (currentPageNumber > 0) {
        selectedAddressId = addressIdSelected

        let recentAddress = existingAddress[0]
        widgetData["listAddress"].groupedAddresses[0] = recentAddress

        groupedAddresses = existingAddress[1].addresses
        let combinedAddress = groupedAddresses.concat(widgetData["listAddress"].groupedAddresses[1].addresses)
        widgetData["listAddress"].groupedAddresses[1].addresses = combinedAddress

        let combinedAddressCta = { ...existingCta, ...addressCta }
        addressCta = combinedAddressCta
    }
    return {
        widget: widgetData,
        selectedAddressId: selectedAddressId,
        addressCta: addressCta,
        totalNumerOfAddress: numberOfAddress + currentPageNumber * totalNumerOfAddress,
        hasMore: hasMore,
        currentPageNumber: currentPageNumber,
    }
}

/**
 * Creating parsed data for reverseGeoData for which this function is called
 * @param {object} data
 * @return {object} addressSelection with it's type and data
 */

export const parseReverseGeoData = (data) => {
    let reverseGeoData = {
        header: data.street2
            ? data.street2
            : data.city
            ? data.city
            : data.state
            ? data.state
            : data.country
            ? data.country
            : data.pincode
            ? data.pincode
            : "",
        address: data.street3,
        pincode: data.pincode ? data.pincode : "",
        city: data.city ? data.city : "",
        state: data.state ? data.state : "",
        country: data.country ? data.country : "",
        geodata_source: data.geodata_source,
    }

    return reverseGeoData
}

/**
 * Creating parsed data for updateAddressDialogBox for which this function is called
 * @param {object} data
 * @return {object} updateAddressDialogBox with it's type and data
 */
export const parseUpdateAddressData = (data) => {
    let updateAddressDialogBox = {
        description: data?.description,
        header: data?.header,
        icon: data?.icon,
        primaryCta: data?.primary_cta?.text,
        secondaryCta: data?.secondary_cta?.text || "",
    }

    return updateAddressDialogBox
}

export const parseAddressById = (addressObj) => {
    let addressById = {
        name: addressObj?.data?.address_name
            ? addressObj?.data?.address_name
            : addressObj?.data?.address_type,
        id: addressObj?.data?.id,
        city: addressObj?.data?.city,
        recipientPhone: addressObj?.data?.number,
        country: addressObj?.data?.country,
        recipientName: addressObj?.data?.name,
        pincode: addressObj?.data?.pincode,
        state: addressObj?.data?.state,
        addressText: addressObj?.data?.street1,
    }

    return addressById
}

export const parseItemReviewList = (data) => {
    let widgets = data?.data?.widgets
    let actionButton = data?.data?.action_button
    let itemReviewList = {}

    widgets.forEach((widget) => {
        switch (widget.type) {
            case "review_cart_items": {
                itemReviewList["header"] = {
                    text: "Review items",
                }
                itemReviewList["actionButton"] = {
                    label: actionButton?.cta?.text,
                    target_url: actionButton?.cta?.target_url,
                    payload: {
                        cartId: widget?.data?.cta?.details?.cart_id,
                        sku_ids: widget?.data?.items.map((item) => {
                            return item?.sku_id
                        }),
                        source: "cart",
                        response_type: "full",
                        types: "pharmacy",
                    },
                }
                itemReviewList["listOfItemsOnCart"] = {
                    groupItems: [
                        {
                            itemInCart: widget?.data?.items.map((item) => {
                                return {
                                    imageUrl: item?.icon,
                                    header: item?.header,
                                    price: item?.prices?.mrp,
                                    discount: item?.prices?.discount,
                                    discountedPrice: item?.prices?.discounted_price,
                                    subHeader: item?.sub_header,
                                    tag: {
                                        label: item?.tag?.text,
                                        backgroundColor: item?.tag?.bg_color,
                                        color: item?.tag?.text_color,
                                    },
                                }
                            }),
                        },
                    ],
                }
            }
        }
    })
    return itemReviewList
}
